<template>
  <v-form
    ref="setProjectThumbnail"
    v-model="isFormValid"
    class="set-project-thumbnail"
    @submit.prevent="submitForm"
  >
    <label class="input-label">Miniatura projektu</label>
    <v-select
      v-model="file"
      placeholder="Nazwa pliku"
      v-bind="props.validatedField"
      :rules="[rules.required]"
      :items="getImagesFiles"
      item-value="id"
      item-text="filename"
      :menu-props="{ 'offset-y': true }"
    >
      <template #item="{item}">
        <div class="set-project-thumbnail__item">
          {{ item.filename }}
          <span class="text-10 ml-1">
            ({{ item.timestamp * 1000 | timestamp }})
          </span>
        </div>
      </template>
    </v-select>

    <v-btn
      class="custom-submit-button mt-2"
      color="primary"
      type="submit"
    >
      Ustaw jako minaturę
    </v-btn>
  </v-form>
</template>

<script>
import props from '@/helpers/componentsProps';
import rules from '@/helpers/validators';
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      props,
      rules,
      file: null,
      isFormValid: true,
    };
  },

  computed: {
    ...mapState('project', [
      'project',
    ]),

    getImagesFiles() {
      return this.project.files.filter((file) => {
        const extension = file.filename.split('.').pop().toLowerCase();
        return ['jpg', 'jpeg', 'png'].includes(extension);
      });
    },
  },

  created() {
    this.file = this.project?.thumbnail?.id;
  },

  methods: {
    ...mapActions('project', [
      'selectThumbnail',
    ]),

    submitForm() {
      this.$refs.setProjectThumbnail.validate();
      if (this.isFormValid) {
        this.selectThumbnail(this.file);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.set-project-thumbnail {
  &__item {
    max-width:380px;
  }
}
</style>
